<template>
  <div class="voucher-container">
    <div class="w-100" @touchstart.stop @touchmove.stop>
      <b-tabs v-model="tabIndex" class="tab-title" fill>
        <b-tab title="Ongoing" active lazy>
          <VoucherDetail status="ongoing" />
        </b-tab>

        <b-tab title="Scheduled" lazy>
          <VoucherDetail status="upcoming" />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import VoucherDetail from "./orderVoucher/VoucherDetail.vue";
export default {
  name: "ChatOrderProduct",
  components: {
    VoucherDetail
  },
  data() {
    return {
      tabIndex: 0
    };
  }
};
</script>

<style lang="scss" scoped>
.voucher-container {
  .tab-title {
    ::v-deep .nav-link,
    ::v-deep .nav-tabs,
    ::v-deep .nav-tabs .nav-link.active,
    ::v-deep .nav-link:hover {
      border: none !important;
      border-bottom: none !important;
    }
  }
}
</style>
